import { put, call, select, takeEvery } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { FETCH_TIME_SLOTS, FETCH_TIME_SLOTS_FAIL, FETCH_TIME_SLOTS_SUCCESS } from '../redux/timeSlotsReducer'
import { TimeSlot } from '../types'
import { RootReducer } from '../redux/rootReducer'

function* FetchTimeSlotsFlow(): Generator<any, void, any> {
  const TTL = 1000 * 60 * 1 // 1 minute
  try {
    const lastFetchedAt = yield select((state: RootReducer) => state.timeSlotsReducer.lastFetchedAt)
    if (lastFetchedAt && Date.now() - new Date(lastFetchedAt).getTime() < TTL) {
      return
    }
    const response: TimeSlot[] = yield call(apiCall, { endpoint: '/tutors/time_slots', method: 'GET', params: {} })
    yield put(FETCH_TIME_SLOTS_SUCCESS(response))
  } catch (error) {
    yield put(FETCH_TIME_SLOTS_FAIL())
    console.log(error)
  }
}

export default function* FetchTimeSlotsSaga(): Generator<any, void, any> {
  yield takeEvery([FETCH_TIME_SLOTS], FetchTimeSlotsFlow)
}
